import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { observer } from 'mobx-react';
import React from 'react';
import { isPresent } from '@seedlang/utils';
import { computed, reaction } from 'mobx';
import { Constants } from '@seedlang/constants';

const Wrapper = styled.div``;

const Row = styled.div`
  display: flex;
  gap: 30px;
`;

@observer
class SettingsUserLanguage extends React.Component {

  @computed get selectedLanguageId() {
    return AppUI.authUserStore?.formCache?.languageId;
  }

  @computed get languageWithCountriesIsSelected() {
    return this.selectedLanguageId && isPresent(Constants.COUNTRIES_FOR_LANGUAGE_ID[this.selectedLanguageId]);
  }

  @computed get englishIsSelected() {
    return this.selectedLanguageId?.startsWith('EN');
  }

  @computed get flagOptions() {
    return Constants.COUNTRIES_FOR_LANGUAGE_ID[this.selectedLanguageId] || [];
  }

  componentDidMount() {
    this.disposer = reaction(
      () => this.selectedLanguageId,
      newLanguageId => {
        if (AppUI.authUserStore?.formCache?.flagCountry && !this.flagOptions.includes(AppUI.authUserStore?.formCache?.flagCountry)) {
          this.props.form.onChange('flagCountry', null);
        }

        if (newLanguageId === 'EN') {
          this.props.form.onChange('flagCountry', 'USA');
        } else if (newLanguageId === 'EN2') {
          this.props.form.onChange('flagCountry', 'GBR');
        } else if (this.flagOptions.length > 0 && !AppUI.authUserStore?.formCache?.flagCountry) {
          this.props.form.onChange('flagCountry', this.flagOptions[0]);
        }
      },
    );
  }

  componentWillUnmount() {
    if (this.disposer) {
      this.disposer();
    }
  }

  render() {
    return (
      <Wrapper>
        <Row>
          { this.props.form.select({
              margin: '0 0 20px 0',
              name: 'languageId',
              label: 'Your Native Language',
              options: AppUI.languageOptions,
            })
          }
          {
            AppUI.siteIsDefault && !this.englishIsSelected &&
              this.props.form.select({
                margin: '0 0 20px 0',
                name: 'englishPreference',
                label: 'English Preference',
                options: [['us', 'American English'], ['uk', 'British English']],
                toolTip: 'English translations are displayed in addition to your native language.',
              })
          }
          {
            AppUI.siteIsDefault && this.languageWithCountriesIsSelected &&
              this.props.form.flagSelect({
                  margin: '0 0 20px 0',
                  name: 'flagCountry',
                  label: 'Flag',
                  toolTip: 'This flag will appear next to English translations.',
                  options: this.flagOptions,
                })
          }
        </Row>
        {
          !this.englishIsSelected && AppUI.siteIsDefault &&
            this.props.form.toggle({
              margin: '0 0 20px 0',
              name: 'onlyShowNativeLanguage',
              label: 'Only show my native language (when possible)',
            })
        }
        <Row>
          {
            AppUI.siteIsDefault &&
              this.props.form.select({
                margin: '0 0 20px 0',
                name: 'deLevelId',
                label: 'Your German Level',
                options: AppUI.levelStore.indexData.map(item => {
                  return {id: item.id, name: item.nameWithAbbreviation};
                }),
              })
          }
          {
            AppUI.siteIsDefault &&
              this.props.form.select({
                margin: '0 0 20px 0',
                name: 'esLevelId',
                label: 'Your Spanish Level',
                options: AppUI.levelStore.indexData.map(item => {
                  return {id: item.id, name: item.nameWithAbbreviation};
                }),
              })
          }
          {
            AppUI.siteIsDefault &&
              this.props.form.select({
                margin: '0 0 20px 0',
                name: 'frLevelId',
                label: 'Your French Level',
                options: AppUI.levelStore.indexData.map(item => {
                  return {id: item.id, name: item.nameWithAbbreviation};
                }),
              })
          }
        </Row>
      </Wrapper>
    );
  }
}

export default SettingsUserLanguage;